<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8 py-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <button
      @click.prevent="showAddForm"
      type="button"
      class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 mt-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:text-sm"
    >
      Новая Глава
    </button>
    <div
      v-if="showModal"
      class="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        >
          <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-6 w-6 text-green-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
              <h3
                class="text-lg leading-6 font-medium text-gray-900"
                id="modal-title"
              >
                Новая Глава
              </h3>
              <ErrorMessage
                v-if="errors.add"
                :error="errors.add"
                class="mt-2"
              />
              <div class="mt-2">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                    >Название</label
                  >
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input
                      v-model="name"
                      type="text"
                      name="name"
                      id="name"
                      :class="[
                        'block w-full pr-10  focus:outline-none  sm:text-sm rounded-md',
                        errors.validationAdd && errors.validationAdd.name
                          ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                          : '',
                      ]"
                    />
                    <div
                      v-if="errors.validationAdd && errors.validationAdd.name"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                    >
                      <svg
                        class="h-5 w-5 text-red-500"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                  <p
                    v-if="errors.validationAdd && errors.validationAdd.name"
                    class="mt-2 text-sm text-red-600"
                  >
                    {{ errors.validationAdd.name[0] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              @click.prevent="addRecord"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Сохранить
            </button>
            <button
              @click.prevent="cancelAdding"
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Item form -->
    <!-- <button type="button" class="btn btn-primary" @click.prevent="showAddForm">
      + Новая Глава
    </button>
    <div
      class="modal fade"
      id="addForm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">New item</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="name" class="col-form-label">Name:</label>
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                v-model="name"
              />
              <div
                class="alert alert-danger"
                v-if="errors.validationAdd && errors.validationAdd.name"
              >
                {{ errors.validationAdd.name[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="cancelAdding"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="addRecord"
            >
              Add
            </button>
          </div>
          <div class="alert alert-danger" v-if="errors.add">
            {{ errors.add }}
          </div>
        </div>
      </div>
    </div> -->
    <!-- END of Add Item form -->

    <!-- Модальное окно для подтверждения удаления -->
    <ModalOkCancel v-bind:data="ModalOkCancelData" v-on:mrok="deleteRecord2" />

    <ErrorMessage v-if="errors.load" :error="errors.load" class="mt-2" />

    <Loader v-if="loading" />
    <div v-else-if="data.length">
      <ErrorMessage v-if="errors.delete" :error="errors.delete" class="mt-2" />
      <ErrorMessage v-if="errors.any" :error="errors.any" class="mt-2" />

      <div class="my-8 flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
            >
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    ></th>

                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      <div>
                        <label
                          for="name"
                          class="block text-sm font-medium text-gray-700"
                          >Наименование</label
                        >
                        <div class="mt-1">
                          <input
                            v-model="f_name"
                            type="text"
                            name="name"
                            id="name"
                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      <label
                        for="chapterstates"
                        class="block text-sm font-medium text-gray-700"
                        >Состояние</label
                      >
                      <select
                        v-model="f_chapterstate_id"
                        name="chapterstates"
                        id="chapterstates"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      >
                        <option value="-1" :selected="true">Все</option>
                        <option
                          v-for="item in chapterstates"
                          :key="item.id"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="block text-sm font-medium text-gray-700">
                        Сортировка
                      </span>
                    </th>
                    <th scope="col" class="relative px-6 py-3">
                      <span class="sr-only">Menu</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="item in filteredData" :key="item.id">
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                    >
                      {{ item.id }}
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-900">
                      <router-link
                        :to="{
                          name: 'adminChapter_show',
                          params: { id: item.id },
                        }"
                        >{{ item.name }}</router-link
                      >
                      <abbr
                        v-if="item.is_final"
                        title="Эта глава - финальная, будет доступна после завершения всех остальных"
                        class="bg-green-500 hover:bg-green-700 text-white px-2 py-1 rounded-full"
                        >fin</abbr
                      >
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {{ item.chapterstate_name }}
                    </td>

                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {{ item.orderby }}
                    </td>
                    <td
                      class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                    >
                      <!-- relative -->
                      <div class="hover:inline-block text-left">
                        <div>
                          <button
                            @click="toggleDropdown(item.id)"
                            type="button"
                            class="bg-gray-100 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                            :id="'options-menu-' + item.id"
                            aria-expanded="true"
                            aria-haspopup="true"
                          >
                            <span class="sr-only">Open options</span>
                            <!-- Heroicon name: solid/dots-vertical -->
                            <svg
                              class="h-5 w-5"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                              />
                            </svg>
                          </button>
                        </div>

                        <!--
                          Dropdown menu, show/hide based on menu state.

                          Entering: "transition ease-out duration-100"
                            From: "transform opacity-0 scale-95"
                            To: "transform opacity-100 scale-100"
                          Leaving: "transition ease-in duration-75"
                            From: "transform opacity-100 scale-100"
                            To: "transform opacity-0 scale-95"
                        -->
                        <div
                          v-if="item.id == dropdownToggled"
                          class="divide-y divide-gray-200 z-40 origin-top-right absolute right-16 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="options-menu"
                        >
                          <div>
                            <div class="py-1" role="none">
                              <router-link
                                :to="{
                                  name: 'adminChapter_edit',
                                  params: { id: item.id },
                                }"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                role="menuitem"
                                >Редактировать главу</router-link
                              >
                            </div>
                          </div>

                          <div>
                            <div class="py-1" role="none">
                              <router-link
                                :to="{
                                  name: 'adminChapter_questions',
                                  params: { chapter_id: item.id },
                                }"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                >Список вопросов</router-link
                              >
                            </div>
                          </div>
                          <div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="publicChapter(item.id)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                Включить Главу в Курс
                              </button>
                            </div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="unpublicChapter(item.id)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                Вернуть Главу в Черновики
                              </button>
                            </div>
                          </div>
                          <div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="setFinalChapter(item.id)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                Сделать Главу финальной
                              </button>
                            </div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="unsetFinalChapter(item.id)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                              >
                                Сделать Главу НЕ финальной
                              </button>
                            </div>
                          </div>
                          <div>
                            <div class="py-1" role="none">
                              <button
                                @click.prevent="askToDeleteRecord(item)"
                                type="button"
                                class="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
                              >
                                УДАЛИТЬ
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- <table class="table mt-4 bg-light shadow p-3 mb-5 rounded">
        <thead>
          <tr>
            <th></th>
            <th>
              <p>Наименование</p>
              <input
                class="form-control"
                type="text"
                name="name"
                id="name"
                v-model="f_name"
              />
            </th>
            <th>
              <p>Состояние</p>
              <select
                class="form-select form-select-sm form-control"
                name="chapterstate"
                id="chapterstate"
                v-model="f_chapterstate_id"
              >
                <option value="-1" :selected="true">Все</option>
                <option
                  v-for="item in chapterstates"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </th>
            <th></th>
            <th class="align-top">
              <p>Сортировка</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredData" :key="item.id">
            <td>{{ item.id }}</td>
            <td>
              <router-link
                :to="{ name: 'adminChapter_show', params: { id: item.id } }"
                >{{ item.name }}</router-link
              >
              <abbr
                v-if="item.is_final"
                title="Эта глава - финальная, будет доступна после завершения всех остальных"
                class="badge badge-info"
                >fin</abbr
              >
            </td>
            <td>{{ item.chapterstate_name }}</td>
         
            <td>
              <ul class="nav nav-pills">
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    data-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >&#9776;</a
                  >
                  <div class="dropdown-menu">
                    <router-link
                      class="alert alert-primary dropdown-item"
                      :to="{
                        name: 'adminChapter_edit',
                        params: { id: item.id },
                      }"
                      >Редактировать главу</router-link
                    >
                    <div class="dropdown-divider"></div>
                    <router-link
                      class="dropdown-item"
                      :to="{
                        name: 'adminChapter_questions',
                        params: { chapter_id: item.id },
                      }"
                      >Список вопросов</router-link
                    >
                    <div class="dropdown-divider"></div>
                    <button
                      type="button"
                      class="btn dropdown-item"
                      @click.prevent="publicChapter(item.id)"
                    >
                      Включить Главу в Курс
                    </button>
                    <button
                      type="button"
                      class="btn dropdown-item"
                      @click.prevent="unpublicChapter(item.id)"
                    >
                      Вернуть Главу в Черновики
                    </button>
                    <div class="dropdown-divider"></div>
                    <button
                      type="button"
                      class="btn dropdown-item"
                      @click.prevent="setFinalChapter(item.id)"
                    >
                      Сделать Главу финальной
                    </button>
                    <button
                      type="button"
                      class="btn dropdown-item"
                      @click.prevent="unsetFinalChapter(item.id)"
                    >
                      Сделать Главу НЕ финальной
                    </button>
                    <div class="dropdown-divider"></div>
                    <button
                      type="button"
                      class="alert alert-danger dropdown-item"
                      @click.prevent="askToDeleteRecord(item)"
                    >
                      УДАЛИТЬ
                    </button>
                  </div>
                </li>
              </ul>
            </td>
            <td>{{ item.orderby }}</td>
          </tr>
        </tbody>
      </table> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
// import jQuery from "jquery";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import ModalOkCancel from "@/components/ModalOkCancel";
import ErrorMessage from "@/components/ErrorMessage";

export default {
  components: {
    Loader,
    PageTitle,
    ModalOkCancel,
    BreadCrumbs,
    ErrorMessage,
  },
  data() {
    return {
      loading: true,
      title: "Список Глав",
      data: [],
      id: 0,
      name: "",
      errors: {
        load: "",
        add: "",
        delete: "",
        edit: "",
        validationAdd: {},
        validationEdit: {},
        any: "",
      },
      ModalOkCancelData: {
        id: 0,
        caption: "",
        message: "",
        show: false,
        style: "",
        okCaption: "Удалить!",
      },
      bcrumbs: [],

      // для фильтрации:
      f_chapterstate_id: -1,
      f_name: "",

      showModal: false,
      dropdownToggled: false,
    };
  },
  computed: {
    filteredData() {
      return this.data.filter(
        (rec) =>
          rec.name.toLowerCase().includes(this.f_name.toLowerCase()) &&
          (rec.chapterstate_id == this.f_chapterstate_id ||
            this.f_chapterstate_id == -1)
      );
    },
  },
  async mounted() {
    this.loadRecords(this.$route.params.course_id);
  },
  methods: {
    toggleDropdown(id) {
      console.log(id);
      if (this.dropdownToggled) {
        this.dropdownToggled = false;
      } else {
        this.dropdownToggled = id;
      }
    },
    clearErrors() {
      this.errors.load = "";
      this.errors.add = "";
      this.errors.delete = "";
      this.errors.edit = "";
      this.errors.any = "";
    },
    async loadRecords(course_id) {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/courses/" + course_id + "/chapters"
        );
        this.data = response.data.chapters;
        this.chapterstates = response.data.chapterstates;
        this.bcrumbs = response.data.bcrumbs;
        //console.log(this.data);
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    showAddForm() {
      this.name = "";
      this.errors.validationAdd = {};
      // this.errors.add = ''
      this.clearErrors();
      // jQuery("#addForm").modal("show");
      this.showModal = true;
    },
    cancelAdding() {
      this.name = "";
      // jQuery("#addForm").modal("hide");
      this.showModal = false;
    },
    //
    // Add new record.
    //
    async addRecord() {
      var course_id = this.$route.params.course_id;
      this.errors.validationAdd = {};
      // this.errors.add = ''
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/courses/" + course_id + "/chapters",
          { name: this.name }
        );
        if (response.status == 200) {
          this.name = "";
          this.loadRecords(course_id);
          // jQuery("#addForm").modal("hide");
          this.showModal = false;
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationAdd = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.add = "Ошибка при создании записи.";
        } else {
          this.errors.add = "Неизвестная ошибка при создании записи.";
        }
      }
    },
    //
    // Delete record.
    //
    /*
        async deleteRecord(id) {
            this.errors.delete = ''
            try {
                let response = await axios.delete('admin/chapters/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    console.log(e.response);
                    console.log(e.response.data);
                    console.log(e.response.data.error);
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },
        */

    //
    // Показываем MessageBox с подтверждением удаления Главы.
    //
    askToDeleteRecord(item) {
      this.clearErrors();
      this.ModalOkCancelData.id = item.id;
      this.ModalOkCancelData.style = "danger";
      this.ModalOkCancelData.caption = "Внимание!";
      this.ModalOkCancelData.message =
        'Вы действительно хотите удалить Главу <strong>"' +
        item.name +
        '"</strong>?';
      this.ModalOkCancelData.show = true;
    },

    //
    // Удалить Главу.
    //
    async deleteRecord2() {
      this.clearErrors();
      var id = arguments[0];
      if (id > 0) {
        try {
          let response = await axios.delete("admin/chapters/" + id);
          if (response.status == 200) {
            // удаление эл-та из списка "на клиенте":
            let index = this.data.findIndex((tmpdata) => tmpdata.id == id);
            this.data.splice(index, 1);
          }
        } catch (e) {
          if (e.response.status == 520) {
            /*
                        console.log(e.response);
                        console.log(e.response.data);
                        console.log(e.response.data.error);
                        */
            this.errors.delete = e.response.data.error;
          } else {
            this.errors.delete = "Неизвестная ошибка при удалении.";
          }
        }
      }
    },

    //
    // Опубликовать Главу (включить её в Курс).
    //
    async publicChapter(id) {
      var course_id = this.$route.params.course_id;
      // this.errors.any = ''
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/chapters/" + id + "/action/public"
        );
        if (response.status == 200) {
          this.loadRecords(course_id);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Ошибка при публикации Главы.";
        }
      }
    },

    //
    // Снять Главу с публикации (вернуть её в Черновики).
    //
    async unpublicChapter(id) {
      var course_id = this.$route.params.course_id;
      // this.errors.any = ''
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/chapters/" + id + "/action/unpublic"
        );
        if (response.status == 200) {
          this.loadRecords(course_id);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Ошибка при снятии Главы с публикации.";
        }
      }
    },

    //
    // Сделать Главу "финальной".
    //
    async setFinalChapter(id) {
      var course_id = this.$route.params.course_id;
      // this.errors.any = ''
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/chapters/" + id + "/action/set_final"
        );
        if (response.status == 200) {
          this.loadRecords(course_id);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Ошибка при редактировании (set_final).";
        }
      }
    },

    //
    // Сделать Главу НЕ "финальной".
    //
    async unsetFinalChapter(id) {
      var course_id = this.$route.params.course_id;
      // this.errors.any = ''
      this.clearErrors();
      try {
        let response = await axios.post(
          "admin/chapters/" + id + "/action/unset_final"
        );
        if (response.status == 200) {
          this.loadRecords(course_id);
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Ошибка при редактировании (unset_final).";
        }
      }
    },
  },
};
</script>

<style scoped>
</style>